import * as React from 'react';
import Project from 'src/entities/Project';
import { RootState } from 'src/reducers/RootReducer';
import { connect, Dispatch } from 'react-redux';
import AcceptsCommitmentInvestmentComponent, {
  AcceptsCommitmentInvestmentComponentProps
} from './AcceptsCommitmentInvestment.component';
import { openModal, OpenModal } from 'src/actions/modal';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';
import Investment from 'src/entities/Investment';
import { setInvestmentData, SetInvestmentDataAction } from 'src/actions/investment/set-data/SetInvestmentData.actions';
import {
  createInvestment,
  CreateInvestmentAction,
  CreateInvestmentSuccess
} from 'src/actions/investment/create/CreateInvestment.actions';
import * as createInvestmentTypes from 'src/actions/investment/create/Types';
import SuccessfulInvestmentContainer from './SuccessfulInvestment.container';
import {
  updateInvestment,
  UpdateInvestmentAction,
  UpdateInvestmentSuccess
} from 'src/actions/investment/update/UpdateInvestment.actions';
import * as updateInvestmentTypes from 'src/actions/investment/update/Types';
import Person from 'src/entities/Person';
import {
  createProjectInterested,
  CreateProjectInterestedAction
} from 'src/actions/project/interested/create/CreateProjectInterested.actions';
import {
  getProjectInterested,
  GetProjectInterestedAction
} from 'src/actions/project/interested/get/GetProjectInterested.actions';
import LoadingContainer from 'src/modules/commons/loading/Loading.container';
import { getInvestment, GetInvestmentAction } from 'src/actions/investment/get/GetInvestment.actions';
import { getProject, GetProjectAction } from 'src/actions/project/get/GetProject.actions';

interface StateProps {
  project?: Project;
  investment?: Investment;
  activeProfile?: Person;
}

interface DispatchProps {

  getProject: (projectId: number) => Promise<GetProjectAction>;

  openModal(component: JSX.Element, className: string): void;

  setInvestmentData(investment?: Investment): SetInvestmentDataAction;

  createInvestment(investment: Investment): Promise<CreateInvestmentAction>;

  updateInvestment(investment: Investment): Promise<UpdateInvestmentAction>;

  getProjectInterested(projectId: number, personId: number, personType: string): void;

  createProjectInterested(projectId: number, person: Person): Promise<CreateProjectInterestedAction>;

  getInvestment(projectId: number, profileId: number, profileType: string): Promise<GetInvestmentAction>;
}

interface Props extends StateProps, DispatchProps {
  modalRef?: Modal;
  reinvestment: boolean;
  handleBackButton?: () => void;
}

class AcceptsCommitmentInvestmentContainer extends React.Component<Props> {

  public render(): React.ReactNode {
    if (!(
      this.props.project &&
      this.props.investment
    )) {
      return <LoadingContainer/>;
    }
    return <AcceptsCommitmentInvestmentComponent {...this.getComponentProps()} />;
  }

  private next(): void {
    if (!this.props.investment) {
      return;
    }

    let investment = new Investment(this.props.investment);
    investment.acceptsCommitment = true;

    this.props.setInvestmentData(investment);

    if (this.props.reinvestment) {
      this.props.updateInvestment(investment).then((response: UpdateInvestmentSuccess) => {
        if (response.type === updateInvestmentTypes.UPDATE_INVESTMENT_SUCCESS) {
          this.props.getProject(this.props.project!.id).then(() => {
            this.props.openModal(<SuccessfulInvestmentContainer/>, 'large');
            this.updateInterest();
          });

        }
      });
    } else {
      this.props.createInvestment(investment).then((response: CreateInvestmentSuccess) => {
        if (response.type === createInvestmentTypes.CREATE_INVESTMENT_SUCCESS) {
          this.props.getProject(this.props.project!.id).then(() => {
            this.props.getInvestment(
              this.props.project!.id,
              this.props.activeProfile!.id,
              this.props.activeProfile!.personType
            );

            this.props.openModal(<SuccessfulInvestmentContainer/>, 'large');
            this.props.setInvestmentData(undefined);
            this.updateInterest();
          });

        }
      });
    }

  }

  private updateInterest(): void {
    if (this.props.project && this.props.activeProfile) {
      this.props.getProjectInterested(
        this.props.project!.id,
        this.props.activeProfile!.id,
        this.props.activeProfile!.personType
      );
    }

  }

  private getComponentProps(): AcceptsCommitmentInvestmentComponentProps {
    if (!(
      this.props.project &&
      this.props.investment
    )) {
      throw new Error('some props are not defined');
    }

    return {
      project: this.props.project,
      modalRef: this.props.modalRef,
      investment: this.props.investment,
      next: () => this.next(),
    };
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
  openModal: (component: JSX.Element, className: string): OpenModal => (
    dispatch(openModal(component, className))
  ),
  setInvestmentData: (investment: Investment): SetInvestmentDataAction => (
    dispatch(setInvestmentData(investment))
  ),
  createInvestment: (investment: Investment): Promise<CreateInvestmentAction> => (
    dispatch(createInvestment(investment))
  ),
  updateInvestment: (investment: Investment): Promise<UpdateInvestmentAction> => (
    dispatch(updateInvestment(investment))
  ),
  getProjectInterested: (
    projectId: number,
    personId: number,
    personType: string
  ): Promise<GetProjectInterestedAction> => (
    dispatch(getProjectInterested(projectId, personId, personType))
  ),
  createProjectInterested: (projectId: number, person: Person): Promise<CreateProjectInterestedAction> => (
    dispatch(createProjectInterested(projectId, person))
  ),
  getInvestment: (
    projectId: number,
    profileId: number,
    profileType: string
  ): Promise<GetInvestmentAction> => (
    dispatch(getInvestment(projectId, profileId, profileType))
  ),
  getProject: (projectId: number): Promise<GetProjectAction> => (
    dispatch(getProject(projectId))
  )
});

const mapStateToProps: (state: RootState) => StateProps = (state: RootState):
  StateProps => ({
  project: state.getProject.project || undefined,
  investment: state.setInvestmentData.investment,
  activeProfile: state.getUser.activeProfile,
});

export default connect(mapStateToProps, mapDispatchToProps)(AcceptsCommitmentInvestmentContainer);



// WEBPACK FOOTER //
// ./src/modules/modals/investment-funnel/AcceptsCommitmentInvestment.container.tsx